export const QUEUE_STORAGE_KEY = 'uploaderState';
export const CHUNK_SIZE = 1024 * 1024 * 1;
